import { Box, Typography } from "@mui/material"

export default function DisplayContadores({
    titulo,
    valor,
    marginY = 1,
    chip = null,
    fontSize = 'inherit',
    fontWeightValue = 'normal',
    onClick
}: DisplayContadoresProps) {
    
    const isClickable = Boolean(onClick);
    
    return (
        <Box 
            display="flex" 
            gap={1} 
            my={marginY}
            onClick={onClick}
            sx={{
                cursor: isClickable ? 'pointer' : 'default',
                '&:hover': isClickable ? {
                    color: 'primary.main',
                    textDecoration: 'underline',
                } : {}
            }}
        >
            <Typography fontSize={fontSize} variant="caption">{titulo}</Typography>
            <Box
                flex={1}
                borderBottom="1px dotted black"
                sx={{ boxSizing: "border-box", height: '14px' }}
            />
            <Box display={'flex'} alignItems={'center'} gap={1}>
                <Typography fontSize={fontSize} fontWeight={fontWeightValue} variant="subtitle2">{valor}</Typography>
                {chip && chip}
            </Box>
        </Box>
    )
}

interface DisplayContadoresProps {
    titulo: string,
    valor: number | string,
    marginY?: number,
    chip?: JSX.Element | null,
    onClick?: () => void
    fontSize?: string
    fontWeightValue?: string | number
}